'use strict';

exports.__esModule = true;
var UrlQueryParamTypes = {
  number: 'number',
  string: 'string',
  object: 'object',
  array: 'array',
  json: 'json',
  date: 'date',
  boolean: 'boolean',
  numericObject: 'numericObject',
  numericArray: 'numericArray'
};

exports.default = UrlQueryParamTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-url-query/lib/UrlQueryParamTypes.js
// module id = 114
// module chunks = 0